import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { APP_NAME, ADMIN_NAVIGATION_LINKS } from '../../constants';
import { AdminNavLinkItem } from '../../types';
import { AcademicCapIcon } from '../icons';
import { useTheme } from '../../contexts/ThemeContext';

const AdminSidebar: React.FC = () => {
  const { colors } = useTheme();
  const linkClasses = "flex items-center px-3 py-3 rounded-md text-sm font-medium transition-colors duration-200";
  const activeLinkClasses = "bg-primary text-white shadow-md";
  const inactiveLinkClasses = "text-neutral-300 hover:bg-neutral-700 hover:text-white";

  return (
    <div className="w-64 h-full flex flex-col fixed shadow-lg" style={{ backgroundColor: colors.background.paper }}>
      <div className="p-4" style={{ borderBottom: `1px solid ${colors.border}` }}>
        <Link to="/admin/dashboard" className="flex items-center space-x-2 text-xl font-bold transition-all duration-300 hover:scale-105">
          <AcademicCapIcon className="h-7 w-7" style={{ color: colors.accent.mint }} />
          <span style={{ 
            background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>{APP_NAME} Admin</span>
        </Link>
      </div>
      <nav className="flex-grow p-4 space-y-2">
        {ADMIN_NAVIGATION_LINKS.map((item: AdminNavLinkItem) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${linkClasses} ${isActive ? 'shadow-md' : ''}`
            }
            style={({ isActive }) => ({
              background: isActive ? `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)` : 'transparent',
              color: isActive ? 'white' : colors.text.secondary
            })}
            onMouseEnter={(e) => {
              if (!e.currentTarget.classList.contains('active')) {
                e.currentTarget.style.backgroundColor = `${colors.accent.mint}10`;
                e.currentTarget.style.color = colors.accent.mint;
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.classList.contains('active')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = colors.text.secondary;
              }
            }}
          >
            {item.icon}
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4" style={{ borderTop: `1px solid ${colors.border}` }}>
         <Link 
            to="/" 
            className="block w-full text-center px-3 py-2.5 rounded-md text-sm font-medium transition-all duration-300 hover:scale-105"
            style={{
              backgroundColor: `${colors.accent.mint}20`,
              color: colors.accent.mint
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = `${colors.accent.mint}30`;
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = `${colors.accent.mint}20`;
              e.currentTarget.style.transform = 'scale(1)';
            }}
        >
            View Public Site
        </Link>
      </div>
    </div>
  );
};

export default AdminSidebar;